const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Display-only: formats dates as DD-Mmm-YYYY (e.g. 26-Jun-2026). Does not affect API or date pickers.
export function formatDisplayDate(dateString) {
    if (!dateString || String(dateString).toLowerCase() === 'null') return '-';

    const s = String(dateString).trim();
    let day;
    let month;
    let year;

    let match = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
        year = +match[1];
        month = +match[2];
        day = +match[3];
    } else if ((match = s.match(/^(\d{2})-(\d{2})-(\d{4})$/))) {
        day = +match[1];
        month = +match[2];
        year = +match[3];
    } else if ((match = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/))) {
        day = +match[1];
        month = +match[2];
        year = +match[3];
    } else if ((match = s.match(/^(\d{1,2})-([a-zA-Z]{3})-(\d{4})$/))) {
        const monthIndex = MONTH_ABBR.indexOf(match[2].toLowerCase());
        if (monthIndex >= 0) {
            return `${String(match[1]).padStart(2, '0')}-${MONTH_ABBR[monthIndex]}-${match[3]}`;
        }
        return s;
    } else {
        return 'Invalid Date';
    }

    if (month < 1 || month > 12 || day < 1 || day > 31) return 'Invalid Date';
    return `${String(day).padStart(2, '0')}-${MONTH_ABBR[month - 1]}-${year}`;
}
